export default __webpack_public_path__ + "static/media/login-icon.ea61eacb.svg";